import { EmbroideryTypeKey, SelectionError } from '../../combination-rules/types'

/**
 * Turns what would stop a submit into messages for the product page. Only a missing required
 * type produces a message — every other rule violation is already refused by the selection
 * provider, so a shopper can never reach one. Empty on a DTC page, where nothing is required.
 *
 * Covers the same case as `EmbroideryProvider.tsx`'s `embroiderySelectionErrorMessages`: a required
 * type left unselected. It leaves out that memo's other messages (placement-required,
 * confirmation-required) because the new selection provider can't reach those states to begin with.
 *
 * @param strings - Copy per type for "this is required".
 */
export const selectionErrorMessagesFromErrors = ({
  selectionErrors,
  strings,
}: {
  selectionErrors: readonly SelectionError[]
  strings: Partial<Record<EmbroideryTypeKey, string>>
}): string[] =>
  selectionErrors.flatMap(error => {
    if (error.reason !== 'MISSING_REQUIRED_TYPE' || !error.typeKey) return []

    const message = strings[error.typeKey]
    return message ? [message] : []
  })
